// extracted by mini-css-extract-plugin
export default {"container_animation":"footerAnimation_container_animation__+P+fd","link_animation":"footerAnimation_link_animation__Fn53F","img_animation":"footerAnimation_img_animation__Kw7Co"};